<template>
    <div>
      <b-form-group :label="field.label" :label-for="`id_${field._id}`">
        <div style="display: flex;">
        <template>
          <b-form-select
            v-model="model"
            type="text"
            autocomplete="no"
            :placeholder="field.placeholder"
            :options="options"
            :text-field="textField"
            :value-field="valueField"
            class="form-control custom-select"
            @change="onChange($event)"
          >
            <option slot="first" selected :value="null" disabled>
              {{ field.placeholder }}
            </option>
          </b-form-select>
        </template>
        <template v-if="isInputField" class="form-control">
          <b-form-input v-model="textInput" type="text" autocomplete="no" :placeholder="field.placeholder"   />
        </template>
        </div>
      </b-form-group>
    </div>
  </template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import request from '@/utils/request'

export default {
 
    props: {
        field: {
            type: Object,
            required: true,
        },
        dataSegmentId: {
            type: String,
            required: true,
        },
        textField: {
            type: String,
            default: 'title',
        },
        valueField: {
            type: String,
            default: '_id',
        },
    },
    data() {
        return {
            model : null,
            value: null,
            textInput:null,
            options: [],
            isDisabled: false,
            country:process.env.VUE_APP_COUNTRY,
            keyArraysByAssociationType:{"companiesList":['occupationInfo.companyName','parents']}
        }
    }, // End of Component > data
  computed: {
    ...mapGetters(['getField']),
    isInputField() {
    if(this.model === "1"){
      this.field.placeholder = this.field.placeholder.replace("Select", "Enter")
    }
      return this.model === '1'; // Check for both empty string and null
    },
  },
  watch:{
    model(value){
      console.log("M1",value)
      if(value && value !="1"){
          this.textInput = null
          let selectedItem = this.options.find(
          (item) => item._id === value)
          if(this.validateSelectedId()){
            this.updateArray({key:this.field.key,value:selectedItem._id,isPush:true,isFormArray:true})
          }else{
            console.log("M2",value,this.field.key,selectedItem.title)
            this.updateField({
                key:this.field.key,
                value:selectedItem.title 
            })
          }
       }else if(value && value=="1"){
        this.updateField({
                key:'occupationInfo.companyName',
                value:null
            })
        this.updateArray({key:'parents',value:'',isPush:false,isFormArray:true})

       }

    },
    textInput(value){
      if(value){
      this.updateField({
                key:'occupationInfo.companyName',
                value:value
            })
          }
    }
  },
  async mounted() {
        let { data } = await request({
                            url: `/configurations/${this.field.association}`,
                            params: {
                                dataSegmentId: this.field.dataSegmentId,
                            },
                        })

        this.options = data.data
        this.updateModelValueOnMount()
        var some = this.field.key.split('.')
        if(this.field.customerDetails)
        { 
          if (this.field.customerDetails[some[0]][some[1]]){
                  let selectedOption = this.options.find((option=>option.title == this.field.customerDetails[some[0]][some[1]]))
             this.model= selectedOption._id
          }else if(this.field.customerDetails.parents && this.field.customerDetails.parents.length > 0 ){
             let selectedOption = this.options.find((option=>option._id.toString() == this.field.customerDetails.parents[0].toString()))
             this.model= selectedOption._id
          }
        }
  },
  methods: {
    ...mapMutations(['updateArray','updateField']),
    updateModelValueOnMount(){
      let keysArray = this.keyArraysByAssociationType[this.field.association]
      if(!this.model){ 
          for (let key of keysArray){
                if(this.getField(key) && typeof this.getField(key) == 'string'){
                  let selectedItem = this.options.find(
                    (item) => item.title === this.getField(key))
                    if(selectedItem && selectedItem._id){
                      this.model =  selectedItem._id
                    }else{
                      this.model = "1"
                      this.textInput = this.getField(key)
                    }
                }
                else if(this.getField(key) && this.getField(key).length > 0 && Array.isArray(this.getField(key))){
                   this.model = this.getField(key)[0]
                }
          }
        }
    },
    isValidMongoId(id) {
      const regex = /^[0-9a-fA-F]{24}$/;
      return regex.test(id);
    },
    validateSelectedId() {
      if (this.model) {
        const id = this.model;
        if (!this.isValidMongoId(id)) {
          console.error(`Invalid MongoDB ID: ${id}`); 
          let lengthOfParents = this.getField("parents").length
            for(let i=0; i < lengthOfParents ; i++){
               this.updateArray({key:'parents',value:'',isPush:false,isFormArray:true})
            }

          this.field.key =  'occupationInfo.companyName'
          return false
        }else{
          this.updateField({
                  key:'occupationInfo.companyName',
                  value:null
              })
          this.updateArray({key:'parents',value:'',isPush:false,isFormArray:true})
          this.field.key =  'parents'
          return true
        }
      }
    },
    onChange(value) {
      // Handle any changes based on the new value (optional)
      this.$emit('change', value); // Emit an event with the changed value
    },
  },
};
</script>